/**
 * @spec docs/specs/features/staking-ui-batched-reads.md (R8)
 *
 * Owner of the user's own balances query: works out the user's wallets once, polls
 * `['balances', sortedOwnAddrs]` every 60 s while the tab is visible, and tells every selector
 * which addresses belong to that query.
 */
import { useMemo, type ReactNode } from 'react';
import { useAllWallets } from '@/hooks/useAllWallets';
import { OwnBalancesContext, balancesKeyFor, useBalancesPoll } from '@/hooks/useBalances';

export function BalancesProvider({ children }: { children: ReactNode }) {
  const { wallets } = useAllWallets();
  const joined = balancesKeyFor(wallets.map((wallet) => wallet.address)).join(',');
  const own = useMemo<readonly string[]>(() => (joined ? joined.split(',') : []), [joined]);
  useBalancesPoll(own);
  return <OwnBalancesContext.Provider value={own}>{children}</OwnBalancesContext.Provider>;
}
